export const hasPermission = <T extends { permissions: Record<P, boolean> }, P extends keyof T['permissions']>(
  obj: T,
  permission: P,
): boolean => {
  return obj.permissions[permission];
};
